"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForceUpdateNftOwnershipResponseToJSON = exports.ForceUpdateNftOwnershipResponseFromJSONTyped = exports.ForceUpdateNftOwnershipResponseFromJSON = void 0;
function ForceUpdateNftOwnershipResponseFromJSON(json) {
    return ForceUpdateNftOwnershipResponseFromJSONTyped(json, false);
}
exports.ForceUpdateNftOwnershipResponseFromJSON = ForceUpdateNftOwnershipResponseFromJSON;
function ForceUpdateNftOwnershipResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'refreshed': json['refreshed'],
        'deleted': json['deleted'],
        'missingMetadata': json['missingMetadata'],
    };
}
exports.ForceUpdateNftOwnershipResponseFromJSONTyped = ForceUpdateNftOwnershipResponseFromJSONTyped;
function ForceUpdateNftOwnershipResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'refreshed': value.refreshed,
        'deleted': value.deleted,
        'missingMetadata': value.missingMetadata,
    };
}
exports.ForceUpdateNftOwnershipResponseToJSON = ForceUpdateNftOwnershipResponseToJSON;
